import { Button, ButtonGroup, Container } from "react-bootstrap";
import { useReferralDashboard } from "../../../../contexts";
import { ReferralDashboardClassic, ReferralDashboardNew } from ".";
import { CallBackModal } from "../../..";
import { useNavigate } from "react-router-dom";

export function ReferralDashboard() {
    const navigate = useNavigate();
    const { mode, activeCallBack, showCallBackModal, handleCloseCallBackModal, toggleMode } = useReferralDashboard();

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center">
                <h1>Referral Dashboard</h1>

                <ButtonGroup size="sm" className="mb-2">
                    <Button variant="outline-info" onClick={() => navigate("/donor-letters")}>
                        Donor Letters
                    </Button>
                    <Button onClick={toggleMode} variant="outline-info">
                        {mode === "classic" ? "View New Dashboard" : "View Classic Dashboard"}
                    </Button>
                </ButtonGroup>
            </div>
            {mode === "classic" ? <ReferralDashboardClassic /> : <ReferralDashboardNew />}
            <CallBackModal callBack={activeCallBack} show={showCallBackModal} onHide={handleCloseCallBackModal} />
        </Container>
    );
}
